export default __webpack_public_path__ + "static/media/t-shirt.5f0badd2.webp";